import {
  type FeedId,
  type OrganizationId,
  type OrganizationType,
  OrganizationTypes,
  type TeamId,
  type UserId,
} from '@mntn-dev/domain-types'

// An organization type channel is a channel for sending messages to all
// users that belong to the specific type or organization (e.g. all brand
// users or all internal users).
export const OrganizationTypeChannel = (organizationType: OrganizationType) =>
  `organization-type:${organizationType}` as const

// An organization channel is a channel for sending messages to all users that
// belong to the specific organization.
export const OrganizationChannel = (organizationId: OrganizationId) =>
  `organization:${organizationId}` as const

// A team channel is a channel for sending messages to all users that
// belong to the specific team.
export const TeamChannel = (teamId: TeamId) => `team:${teamId}` as const

// A user channel is a channel for sending messages to a specific user.
export const UserChannel = (userId: UserId) => `user:${userId}` as const

// A feed channel is a channel for sending messages to all users that
// have subscribed to the specific feed.
export const FeedChannel = (feedId: FeedId) => `feed:${feedId}` as const

// This is the easiest way to broadcast a message to all users.
export const BroadcastChannel = OrganizationTypes.map(OrganizationTypeChannel)

export type ChannelName =
  | ReturnType<typeof OrganizationTypeChannel>
  | ReturnType<typeof OrganizationChannel>
  | ReturnType<typeof TeamChannel>
  | ReturnType<typeof UserChannel>
  | ReturnType<typeof FeedChannel>
